import { api } from '../../config/ApiConfig';

export const States = {
  all: () => api.get('/v1/states'),
  cities: (stateId) => api.get(`/v1/states/${stateId}/cities`),
}